/* eslint-disable new-cap */
import {
  Noto_Sans,
  Noto_Sans_Thai,
  Noto_Sans_Thai_Looped,
} from "next/font/google";

// Variable Font
const notoSans = Noto_Sans({
  subsets: ["latin"],
  variable: "--font-noto-sans",
});

// Variable Font
const notoSansThai = Noto_Sans_Thai({
  subsets: ["thai"],
  variable: "--font-noto-sans-thai",
});

// Static Font
const notoSansThaiLooped = Noto_Sans_Thai_Looped({
  subsets: ["thai"],
  variable: "--font-noto-sans-thai-looped",
  // light, regular, medium, bold (based on radix theme value)
  weight: ["300", "400", "500", "700"],
});

const variable = `${notoSans.variable} ${notoSansThai.variable} ${notoSansThaiLooped.variable}`;

const font = {
  notoSans,
  notoSansThai,
  notoSansThaiLooped,
  variable,
};

export { font, variable as fontVariable };
